const de = {
  submit: 'Speichern',
  cancel: 'Abbrechen',
  name: 'Liste',
  recipients: 'Empfänger',
  add: 'Hinzufügen',
}
export default de;